import { useTranslation } from 'react-i18next';
import { ON_CHAIN_BBG_LOGO } from '../lib/tokenLogos';

type BbgInfoModalProps = {
  isOpen: boolean;
  bubbleGameLink: string | null;
  onClose: () => void;
};

export default function BbgInfoModal({
  isOpen,
  bubbleGameLink,
  onClose,
}: BbgInfoModalProps) {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <div
      className="modal-backdrop"
      role="presentation"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
    >
      <section className="bbg-info-modal" role="dialog" aria-modal="true" aria-label={t('bbt.bbgTokenName')}>
        <div className="modal-header modal-header-close-only">
          <button className="modal-close-button" type="button" onClick={onClose} aria-label={t('bbt.closeBbg')}>
            ×
          </button>
        </div>

        <div className="bbt-info-content">
          <div className="bbg-info-identity">
            <img className="bbg-info-logo" src={ON_CHAIN_BBG_LOGO} alt="BBG logo" />
            <strong>{t('bbt.bbgTokenName')}</strong>
          </div>
          <p className="bbg-info-description">{t('bbt.bbgDescription')}</p>
          {bubbleGameLink ? (
            <a className="auth-button bbg-info-game-button" href={bubbleGameLink}>
              {t('bbt.enterBubbleGame')}
            </a>
          ) : (
            <p className="bbt-info-link-unavailable">{t('bbt.bubbleGameDeepLinkNotConfigured')}</p>
          )}
        </div>
      </section>
    </div>
  );
}
